var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.72,
    height: 23.146,
    viewBox: "0 0 24.72 23.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;stroke:#000;stroke-width:.5px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message",
    transform: "translate(.25 .267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    d: "M24.2 25.366a.358.358 0 0 0-.022-.123.618.618 0 0 0-.244-.344l-3.467-2.41V19.9a.62.62 0 0 0-.62-.62h-3.988l-3.394-2.359a.62.62 0 0 0-.706 0l-3.416 2.364H4.372a.62.62 0 0 0-.62.62v2.553L.268 24.866a.619.619 0 0 0-.267.5v.011l.017 13.447a.62.62 0 0 0 .62.619l22.962-.031a.62.62 0 0 0 .619-.621zM20.468 24l1.982 1.377-1.982 1.378zm-8.358-5.81l1.576 1.1h-3.16zm-7.118 2.335h14.236v7.092l-4.78 3.323-1.948-1.512-.009-.006a.62.62 0 0 0-.752.006l-1.963 1.523-4.784-3.306zm-1.24 3.441v2.821l-2.041-1.41zm-2.51 2.6l7.506 5.187-7.491 5.81zM2.454 38.2l9.665-7.5 9.631 7.47zm13.021-6.464l7.487-5.205.015 11.025z",
    className: "cls-1",
    "data-name": "Path 54",
    transform: "translate(0 -16.814)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(7.291 6.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    d: "M163.141 147.713h-8.4a.62.62 0 1 0 0 1.241h8.4a.62.62 0 0 0 0-1.241z",
    className: "cls-1",
    "data-name": "Path 55",
    transform: "translate(-154.122 -147.713)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(7.291 9.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    d: "M163.141 215.9h-8.4a.62.62 0 1 0 0 1.241h8.4a.62.62 0 0 0 0-1.241z",
    className: "cls-1",
    "data-name": "Path 56",
    transform: "translate(-154.122 -215.895)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.c7e84fac.svg";
export { ForwardRef as ReactComponent };